export default __webpack_public_path__ + "static/media/data-analytic.7cbbac2b.jpeg";